import firebase from 'firebase/app'
import 'firebase/firestore'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false

const config = {
  apiKey: 'AIzaSyDxUh0OA61nukmQAmIpu1pNImQrItG3h94',
  authDomain: 'shanghai-blue-dragon.firebaseapp.com',
  databaseURL: 'https://shanghai-blue-dragon.firebaseio.com',
  projectId: 'shanghai-blue-dragon',
  storageBucket: 'shanghai-blue-dragon.appspot.com',
  messagingSenderId: '285068381579'
}
firebase.initializeApp(config)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
